import ModalVersoesPisCofins from "../../../components/PisCofins/ModalVersoes";
import { usePreviaPisCofins } from "../PreviaPisCofinsContext";

const ModalVersoesPisCofinsPage = ({
  open,
  onClose,
  idPrevia,
  tipoPrevia,
  isProjeto,
  dadosEmpresa,
  onDataUpdated,
}) => {
  return (
    <ModalVersoesPisCofins
      open={open}
      onClose={onClose}
      idPrevia={idPrevia}
      tipoPrevia={tipoPrevia}
      isProjeto={isProjeto}
      contextHook={usePreviaPisCofins}
      dadosEmpresa={dadosEmpresa}
      onDataUpdated={onDataUpdated}
    />
  );
};

export default ModalVersoesPisCofinsPage;
